<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中……"
    element-loading-spinner="el-icon-loading"
  >
    <el-row type="flex" justify="center">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span
              ><b v-if="$route.query.formData">职位预览</b
              ><b v-else>职位信息</b></span
            >
            <slot name="footBtn" :form="form">
              <el-button
                icon="el-icon-back"
                style="float: right"
                type="success"
                plain
                @click="back"
                >返回</el-button
              >
            </slot>
          </div>
          <el-scrollbar>
            <el-row>
              <h2>
                <span title="职位名称">{{ form.name }}</span>
                <el-tag style="float: right">{{ form.postType }}</el-tag>
              </h2>
            </el-row>
            <el-row title="单位">
              <zr-icon
                icon="el-icon-office-building"
                style="color: #1890ff"
              /><span style="margin-left: 6px">{{ form.publishDept }}</span>
            </el-row>
            <el-row title="地点">
              <zr-icon
                icon="el-icon-map-location"
                style="color: #1890ff"
              /><span style="margin-left: 6px">{{ form.workAddress }}</span>
            </el-row>
            <el-row>
              <el-col :span="16" title="学科类别"
                ><span class="fa fa-address-card-o" style="color: #1890ff" />
                <span style="margin-left: 6px">{{ form.science }}</span>
              </el-col>
              <el-col :span="8" title="学历">
                <span class="fa fa-mortar-board" style="color: #1890ff" />
                <span style="margin-left: 6px">{{
                  form.eduRequireAndOver
                    ? form.eduRequire + "及以上"
                    : form.eduRequire
                }}</span>
              </el-col>
            </el-row>
            <el-row title="专业要求">
              <span class="fa fa-file-text-o" style="color: #1890ff" /><span
                style="margin-left: 6px"
                >{{ form.careerRequire }}</span
              >
            </el-row>
            <el-row title="科研方向">
              <span class="fa fa-eye" style="color: #1890ff" /><span
                style="margin-left: 6px"
            >{{ form.researchOrientations }}</span
            >
            </el-row>
            <el-row>
              <el-col :span="16" title="工作年限"
                ><span
                  class="fa fa-calendar-times-o"
                  style="color: #1890ff"
                /><span style="margin-left: 6px">{{
                  form.workYear
                    ? form.workYearAndOver
                      ? form.workYear + "年" + "及以上"
                      : form.workYear + "年"
                    : "不限"
                }}</span>
              </el-col>
              <el-col :span="8" title="人数">
                <zr-icon icon="users" style="color: #1890ff" /><span
                  style="margin-left: 6px"
                  >{{ form.requireNum ? form.requireNum + "人" : "不限" }}</span
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="!$route.query.formData" :span="16" title="发布时间"
                ><zr-icon icon="el-icon-time" style="color: #1890ff" /><span
                  style="margin-left: 6px"
                  >{{ dateFormat(form.publishDate) }}</span
                >
              </el-col>
              <el-col :span="8" title="截止日期">
                <zr-icon icon="el-icon-timer" style="color: #1890ff" /><span
                  style="margin-left: 6px"
                  >{{ dateFormat(form.endDate) }}</span
                >
              </el-col>
            </el-row>
            <el-row> <span class="spanTitle">职位介绍：</span></el-row>
            <el-row>
              <el-input
                v-model="form.remark"
                aria-disabled="true"
                type="textarea"
                show-word-limit
                :rows="5"
                :autosize="{ minRows: 5, maxRows: 25 }"
                readonly
              ></el-input>
            </el-row>
            <el-row> <span class="spanTitle">单位介绍：</span></el-row>
            <el-row>
              <el-input
                v-model="form.deptInfo"
                aria-disabled="true"
                type="textarea"
                show-word-limit
                :rows="5"
                :autosize="{ minRows: 5, maxRows: 25 }"
                readonly
              ></el-input>
            </el-row>
          </el-scrollbar>
          <el-divider v-if="!$route.query.formData" />
          <slot
            v-if="curRole == 'user' || curRole == 'anonymous'"
            name="footBtn"
            :form="form"
          >
            <!--不是预览-->
            <el-button
              v-if="!$route.query.formData"
              icon="el-icon-circle-check"
              type="primary"
              style="float: right; margin-bottom: 10px"
              @click="post"
              >简历投递</el-button
            >
          </slot>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getBasicData, searchPostInfoById } from "@/api/job/postInfo";
import { getDepartmentByDeptCode } from "@/api/recruit/hr/recruitInfo";
import { mapGetters } from "vuex";
import treeHelper from "../../../../mock/utils/treeHelper";
import merge from "webpack-merge";
let query = {};
let prePageName = undefined;
export default {
  name: "PostInfoEdit",
  data() {
    return {
      loading: true,
      form: {},
      originalForm: {}, // 未翻转的数据
      deptDesc: {}, // 登录人部门信息
      postTypeArray: [],
      eduTypeArray: [],
      scienceTypeArray: [],
      workAddressArray: [],
    };
  },
  computed: {
    ...mapGetters({
      curRole: "user/curRole",
      deptCode: "user/deptCode",
    }),
  },
  async created() {
    await this.getPostTypeArray();
    await this.getEduTypeArray();
    await this.getScienceTypeArray();
    await this.getWorkAddressArray();
    // 编辑时预览的数据
    if (this.$route.query.formData) {
      // 查询登录用户部门信息
      let res = await getDepartmentByDeptCode({ deptCode: this.deptCode });
      if (res.success) {
        this.postTypeArray = this.$route.query.postTypeArray;
        this.eduTypeArray = this.$route.query.eduTypeArray;
        this.scienceTypeArray = this.$route.query.scienceTypeArray;
        this.workAddressArray = this.$route.query.workAddressArray;
        let formData = JSON.parse(this.$route.query.formData.toString());
        this.originalForm = JSON.parse(JSON.stringify(formData));
        this.form = this.dataTurn(formData);
        this.form.deptInfo = res.data.remark;
        this.form.publishDept = res.data.name;
        this.loading = false;
      } else {
        this.$message.error({ showClose: true, message: res.message });
        setTimeout(() => {
          this.loading = false;
        }, 5000);
      }
    } else if (this.$route.query.positionInfoId) {
      // 查询的数据
      await this.getFormData(this.$route.query.positionInfoId);
    } else {
      this.$message.warning({ showClose: true, message: "页面传参错误" });
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    }
  },
  beforeRouteEnter(to, from, next) {
    query = from.query;
    prePageName = from.name;
    next();
  },
  methods: {
    //职位类别
    async getPostTypeArray() {
      let res = await getBasicData({ typeCode: "postType" });
      if (res.success) {
        this.postTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //学历要求
    async getEduTypeArray() {
      let res = await getBasicData({ typeCode: "eduRequire" });
      if (res.success) {
        this.eduTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //学科类别
    async getScienceTypeArray() {
      let res = await getBasicData({ typeCode: "scienceType" });
      if (res.success) {
        this.scienceTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //工作地点
    async getWorkAddressArray() {
      let res = await getBasicData({ typeCode: "workPlace" });
      if (res.success) {
        this.workAddressArray = treeHelper.generateTreeSmart(
          res.data,
          "parentId",
          "id"
        );
        this.removeEmptyChildren(this.workAddressArray);
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    // 删除树中节点的children为空的节点的children
    removeEmptyChildren(node) {
      node.forEach((item) => {
        if ("children" in item && item.children.length === 0) {
          delete item.children;
        } else if ("children" in item && item.children.length) {
          this.removeEmptyChildren(item.children);
        }
      });
    },
    // 查询表单数据
    async getFormData(positionInfoId) {
      let res = await searchPostInfoById({
        positionInfoId: positionInfoId,
        isUpdateViewCount:
          this.curRole == "user" || this.curRole == "anonymous" ? true : false,
      });
      if (res.success) {
        let formData = res.data;
        this.form = this.dataTurn(formData);
        this.loading = false;
      } else {
        this.$message.error({ showClose: true, message: res.message });
        setTimeout(() => {
          this.loading = false;
        }, 5000);
      }
    },
    // 表单数据翻转
    dataTurn(formData) {
      let form = formData;
      // 职位类别
      for (let i in this.postTypeArray) {
        if (this.postTypeArray[i].code == formData.postType) {
          form.postType = this.postTypeArray[i].name;
          break;
        }
      }
      // 学历要求
      for (let i in this.eduTypeArray) {
        if (this.eduTypeArray[i].code == formData.eduRequire) {
          form.eduRequire = this.eduTypeArray[i].name;
          break;
        }
      }
      // 学科类别
      let scienceString = "";
      for (let i in formData.science) {
        for (let j in this.scienceTypeArray) {
          if (this.scienceTypeArray[j].code == formData.science[i]) {
            scienceString += this.scienceTypeArray[j].name + ",";
            break;
          }
        }
      }
      scienceString = scienceString.substr(0, scienceString.length - 1);
      form.science = scienceString;
      // 工作地点
      let workAddressString = "";
      let workAddresslist = [];
      workAddresslist = this.treeToArray(
        this.workAddressArray,
        workAddresslist
      );
      for (let i in formData.workAddress) {
        for (let j in workAddresslist) {
          if (workAddresslist[j].code == formData.workAddress[i]) {
            workAddressString += workAddresslist[j].name + ",";
            break;
          }
        }
      }
      workAddressString = workAddressString.substr(
        0,
        workAddressString.length - 1
      );
      form.workAddress = workAddressString;
      return form;
    },
    // 树转数组
    treeToArray(treeList, newArr = []) {
      treeList.forEach((item) => {
        const { children } = item;
        if (children) {
          delete item.children;
          if (children.length) {
            newArr.push(item);
            return this.treeToArray(children, newArr);
          }
        }
        newArr.push(item);
      });
      return newArr;
    },
    post() {
      const positionInfoId = this.$route.query.positionInfoId;
      const query = this.$route.query ? this.$route.query : {};
      if (this.curRole == "anonymous") {
        this.$router.push({
          path: "/login",
          query: { ...this.$route.query, redirect: "/positionView/index" },
        });
        this.$message.warning({ showClose: true, message: "请先登录" });
      } else if (this.curRole == "user") {
        this.$router.push({
          path: "/applicant/personalResume",
          query: {
            ...query,
            positionInfoId: this.$route.query.positionInfoId,
            researchOrientations: this.form.researchOrientations,
            isPost: true,
          },
        });
      } else {
        this.$message.warning({
          showClose: true,
          message: "当前用户不支持简历投递",
        });
      }
    },
    back() {
      if (this.$route.query.formData) {
        this.$router.push({
          path: "/positionEdit/index",
          query: { ...query, formData: JSON.stringify(this.originalForm) },
        });
      } else {
        this.$router.back();
      }
    },
    dateFormat(value) {
      if (value && typeof value == "string") {
        return value.substr(0, 10);
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped>
.multipleSelect {
  width: 100%;
}
>>> .el-card__body {
  padding-top: 0px;
}
.el-button {
  margin-left: 10px;
}
.el-form {
  height: 590px;
}
.el-row {
  margin-top: 10px;
}
.spanTitle {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>
